import { fetchWithAuth } from "../auth"
import { useState, useEffect } from 'react';
import '../index.css';
import { useParams, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function gf_timestamp(stringtime) {
  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);
  if (isNumeric(stringtime)) {
    let unix_timestamp = stringtime;
    var a = new Date(unix_timestamp * 1000);

    var month = ("0" + (a.getMonth() + 1)).slice(-2);
    var day = ("0" + a.getDate()).slice(-2);
    var hour = ("0" + a.getHours()).slice(-2);
    var min = ("0" + a.getMinutes()).slice(-2);
    var sec = ("0" + a.getSeconds()).slice(-2);

    var time = hour + ':' + min + ':' + sec + "  " + day + "/" + month;
    return time;
  } else {
    return stringtime;
  }
}

const BE_Log = () => {
    const { serial } = useParams(); // get serial from url, if present
    const location = useLocation();
    const navigate = useNavigate();
    const [belogState, setBelogState] = useState([]);

    useEffect(() => {
        f_aggiorna();
    }, []);

    const serialValue = serial ?? undefined;
    const url_log = serialValue ? `/be_log/${encodeURIComponent(serialValue)}` : '/be_log';

    async function f_aggiorna() {
        await fetchWithAuth(url_log, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setBelogState(data);
            })
    }

    async function deleteLog(event) {
        await fetchWithAuth(url_log, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                f_aggiorna()
            })
    }

    return (
        <div>
            <button onClick={() => {
                if (serial) {
                  navigate(`/device/${encodeURIComponent(serialValue)}`, {
                    state: {
                      location: location.state.location,
                      house: location.state.house
                    }
                  })
                } else {
                  navigate("/")
                }
              }}
            >
                Back
            </button>
            <button onClick={() => {setBelogState([]); f_aggiorna();} }>
                Aggiorna
            </button>
            <button onClick={() => {if (window.confirm("Eliminare il log del backend?")) deleteLog()} }>
                Pulisci
            </button>

            <table>
                <tbody>
                    <tr>
                        <th className="title">Data/Ora</th>
                        {/* <th className="title">Tipo</th> */}
                        <th className="title">Luogo</th>
                        <th className="title">Casa</th>
                        <th className="title">Evento</th>
                    </tr>
                    {belogState
                        .slice() // make a copy before reversing to avoid mutating state
                        .reverse()
                        .map((mapB, index) => {
                            const bgColor =
                                mapB.type === 0
                                    ? 'transparent'
                                    : mapB.type === 1
                                        ? 'lightblue'
                                        : mapB.type === 2
                                            ? 'blue'
                                            : 'gray';
                            return (
                                <tr key={`${mapB.time}-${index}`} style={{ backgroundColor: bgColor }}>
                                    <td>{gf_timestamp(mapB.time)}</td>
                                    {/* <td>{mapB.type}</td> */}
                                    <td>{mapB.location}</td>
                                    <td>{mapB.house}</td>
                                    <td>{mapB.event}</td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    )
};

export default BE_Log;
